import { render, staticRenderFns } from "./EpsPiContactForm.vue?vue&type=template&id=24f48b66&scoped=true"
import script from "./EpsPiContactForm.vue?vue&type=script&lang=js"
export * from "./EpsPiContactForm.vue?vue&type=script&lang=js"
import style0 from "./EpsPiContactForm.vue?vue&type=style&index=0&id=24f48b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f48b66",
  null
  
)

export default component.exports